import { ChainId } from '@1inch-community/models';
import { isL2Chain } from './layer2-chain';
export const chainViewConfig = {
    [ChainId.eth]: {
        name: 'Ethereum',
        iconName: 'eth24',
        color: ['#627EEA', '#A3B9FD'],
    },
    [ChainId.arbitrum]: {
        name: 'Arbitrum',
        iconName: 'arbitrum24',
        color: ['#2C374B', '#28A0F0'],
    },
    [ChainId.op]: {
        name: 'Optimism',
        iconName: 'op24',
        color: ['#FF0420', '#FF758C'],
    },
    [ChainId.zkSyncEra]: {
        name: 'zkSync Era',
        iconName: 'zkSyncEra24',
        color: ['#8C8DFC', '#C8C8FE'],
    },
    [ChainId.bnb]: {
        name: 'BNB Smart Chain',
        iconName: 'bnb24',
        priority: 1,
        color: ['#F3BA2F', '#FFDD7A'],
    },
    [ChainId.matic]: {
        name: 'Polygon',
        iconName: 'matic24',
        priority: 1,
        color: ['#8247E5', '#C49BFF'],
    },
    [ChainId.gnosis]: {
        name: 'Gnosis',
        iconName: 'gnosis24',
        color: ['#04795B', '#4DC5A3'],
    },
    [ChainId.avalanche]: {
        name: 'Avalanche',
        iconName: 'avalanche24',
        color: ['#E84142', '#FF8A7C'],
    },
    [ChainId.fantom]: {
        name: 'Fantom',
        iconName: 'fantom24',
        color: ['#1969FF', '#77AFFF'],
    },
    [ChainId.aurora]: {
        name: 'Aurora',
        iconName: 'aurora24',
        color: ['#70D44B', '#B8F59E'],
    },
    [ChainId.klaytn]: {
        name: 'Klaytn',
        iconName: 'klaytn24',
        color: ['#FF5100', '#FF9F6A'],
    },
};
export const chainList = Object.keys(chainViewConfig)
    .map((chainId) => ({ ...chainViewConfig[chainId], chainId: Number(chainId) }))
    .sort((info1, info2) => {
    if (info1.chainId == ChainId.eth)
        return -1;
    if (info2.chainId == ChainId.eth)
        return 1;
    if (isL2Chain(info1.chainId))
        return -1;
    if (isL2Chain(info2.chainId))
        return 1;
    return (info2.priority ?? 0) - (info1.priority ?? 0);
});
//# sourceMappingURL=chain-view-config.js.map